export default __webpack_public_path__ + "static/mobile-ppq-modal-images-5cc570b498bd8b913169fb0f7b13664c.png";